<template>
  <div class="list-illustration">
    <div class="list-illustration__text">
      <h3 class="list-illustration__title">{{ title }}</h3>
      <div class="list-illustration__description">{{ description }}</div>
      <div>
      </div>
    </div>

    <EmptyListIllustration />

    <slot></slot>
  </div>
</template>

<script>
import EmptyListIllustration from "../illustration/empty-list-illustration";

export default {
  components: {
    EmptyListIllustration
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
  },
}
</script>

<style lang="scss" scoped>
.list-illustration {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-bottom: 50px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  svg {
    width: 100%;
    max-width: 400px;
    display: block;
    margin: 0 auto 20px;
  }

  &__text {
    min-width: 300px;
  }

  &__title {
    font-size: 21px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  &__description {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>
